module.exports = new __parcel__URL__("step_three_vector_dark.dfad81df.png").toString();